module.exports = __webpack_public_path__ + "static/img/slide_3_en.c4845d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/slider/slide_3_en.png
// module id = DKqG
// module chunks = 0